import React, {useEffect, useState} from 'react';
import "./orderMainFoodComponent.scss";
import OrderMainFoodPath from "./components/OrderMainFoodPath";
import OrderMainFoodCategory from "./components/OrderMainFoodCategory";
import OrderMainFoodProductList from "./components/OrderMainFoodProductList";
import {useParams} from "react-router-dom";
import OrderHeadSectionComponent from "../../components/headSection/components/OrderHeadSectionComponent";
import { UseGetAllActiveMealAds, UseGetMealAdById } from "../../api/useMeal";

const getCategoryName = (category: string) => {
    const words = category.split("-");
    if (words.length === 1) {
        return words[0].charAt(0).toUpperCase() + words[0].slice(1);
    } else {
        const firstWord = words[0];
        const restOfWords = words.slice(1).join(" ");
      return firstWord.charAt(0).toUpperCase() + firstWord.slice(1) + " " + restOfWords;
    }
}

const OrderMainFoodComponent = () => {
  const { category, details } = useParams();

  const [selectedCategory, setSelectedCategory] = useState<string>(category ? getCategoryName(category) : "All");
  const [foodsData, setFoodsData] = useState<any>([]);
  const [categories, setCategories] = useState<any>([]);

    useEffect(() => {
      if (details) {
        UseGetMealAdById(details).then((response: any) => {
          console.log("UseGetMealAdById response: ", response);
          if (response && response.status === 200) {
            const fetchedData = response.result;

            console.log("Fetched: ", fetchedData);
          }
        });
      }
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [selectedCategory]);
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await UseGetAllActiveMealAds();
        console.log("UseGetAllMealAds response: ", response);
        if (response && response.status === 200 && response.result.length > 0) {
          const fetchedData = response.result;
          const categoriesMap = new Map<string, any[]>();
          
          fetchedData?.forEach((item: any) => {
            if (item?.isAvailable) {
              item.category.forEach((category: string) => {
                const normalizedCategory = category.toLowerCase();
                console.log("normalizedCategory: ", normalizedCategory);
                if (!categoriesMap.has(normalizedCategory)) {
                  categoriesMap.set(normalizedCategory, []);
                }
                categoriesMap.get(normalizedCategory)!.push(item);
              });
            }
          });
          
          setFoodsData(fetchedData?.filter((item: any) => item?.isAvailable) || []);
          
          //setFoodsData(categoriesMap);
          
          let categoriesTmp = categoriesMap ? Array.from(categoriesMap.entries()).flatMap(([category, items]: any) => category) : [];
          setCategories(categoriesTmp);
        } else {
          setFoodsData([]);
        }
      } catch (error) {
        console.log(error);
      } finally {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    };
    
    fetchData().then(r => console.log("r: ", r));
  }, []);
  
  return (
        <div className="orderMainFoodComponent__container">
            <OrderHeadSectionComponent />

            <OrderMainFoodPath
                path={["Food", selectedCategory ? getCategoryName(selectedCategory) : ""]}
                selectedCategory={selectedCategory}
            />
            <OrderMainFoodCategory
                selectedCategory={getCategoryName(selectedCategory)}
                setSelectedCategory={setSelectedCategory}
                categories={categories || []}
            />
            <OrderMainFoodProductList
                selectedCategory={getCategoryName(selectedCategory)}
                data={foodsData || []}
            />
        </div>
    );
};

export default OrderMainFoodComponent;